module.exports = __webpack_public_path__ + "static/media/IMG_5043.f8783629.JPG";